import React from "react";
import { useNavigate } from "react-router-dom";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";

const ProfilePromotionsDisplay = ({ promotions }) => {
  const nav = useNavigate();

  if (!promotions || promotions.length === 0) {
    return null;
  }

  return (
    <div className="border-2 border-purple-200 bg-gradient-to-r from-purple-50 to-indigo-50 rounded-lg p-4 mb-6">
      <h2 className="text-base font-bold text-purple-900 mb-3">
        Featured Professionals
      </h2>
      <div className="flex flex-wrap gap-3">
        {promotions.map((promotion) => (
          <div
            key={promotion.promotion_id}
            className="bg-white rounded-lg shadow-sm px-3 py-2 border border-purple-100 hover:shadow-md hover:scale-[1.02] transition-all cursor-pointer flex items-center gap-3"
            onClick={() => nav(`/user/${promotion.user_id}`)}
          >
            {/* Profile Photo */}
            <img
              src={
                promotion.picture_url
                  ? cloudinaryUrl(promotion.picture_url)
                  : "/error.png"
              }
              alt={`${promotion.legal_first_name} ${promotion.legal_last_name}`}
              className="w-10 h-10 rounded-full object-cover border-2 border-purple-200 flex-shrink-0"
            />

            {/* Info */}
            <div className="min-w-0">
              <h3 className="font-bold text-gray-800 text-xs leading-tight truncate">
                {promotion.legal_first_name} {promotion.legal_last_name}
              </h3>
              {promotion.position && (
                <p className="text-[10px] text-gray-500 truncate">
                  {promotion.position}
                </p>
              )}
              {promotion.phone_number && (
                <p className="text-[10px] text-gray-500 font-mono truncate">
                  {promotion.phone_number}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfilePromotionsDisplay;
